import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'

import GroupedStackedColumn from '../charts/GroupedStackedColumn';
// import { AreaChart } from '../charts/AreaChart';
import {
  removeCardType,
  transformProductGroupedStack,
  transformDynamicSegmentData,
} from '../dash-util';
import { Card } from '@mui/material';
import { TankProductCard } from '../cards/TankProductCard';
import { GenericSegmentCard } from '../cards/GenericSegmentCard';


export function LogisticsView({
  cardsData,
  regressionData,
  productData,
  periodFilter,
  setPeriodFilter
}) {

  const orderedCards = removeCardType(cardsData, 'Trucks Enroute')
    ?.sort((a, b) => a.value - b.value);

  const [excoGroupedStacked, setExcoGroupedStacked] = useState([]);
  const [showGroupedLegend, setShowGroupedLegend] = useState(false);

  useEffect(() => {
    const groupedStacked = transformProductGroupedStack(regressionData);
    setExcoGroupedStacked(groupedStacked);

    const showLegend = !groupedStacked.series.every((item) => item.data.length === 0);
    setShowGroupedLegend(showLegend);

  }, [cardsData, regressionData, productData, periodFilter]);

  return (
    <>
    <Grid container spacing={3}>

      {orderedCards?.length > 0
        ? orderedCards.map((d, index) => (
          <Grid size={{ lg: 3, sm: 6, xs: 12 }} key={d.type}>
            <TankProductCard
              index={index}
              data={d}
            />
          </Grid>
        )) :
        [...Array(4)].map((x, i) => (
          <Grid size={{ lg: 3, sm: 6, xs: 12 }} key={`place-holder-${i}`}>
            <Card sx={{ height: '100%' }}>

            </Card>
          </Grid>
        ))
      }
    </Grid>

    <Grid container spacing={3} sx={{mt: 3}}>
      <Grid size={{ xs: 8 }} key="lv-grouped stacked">
        {/* <AreaChart /> */}
        <GroupedStackedColumn
          series={excoGroupedStacked?.series}
          categories={excoGroupedStacked?.categories}
          height={350}
          title={"Availble Product"}
          periodFilter={periodFilter}
          setPeriodFilter={setPeriodFilter}
          showLegend={showGroupedLegend}
        />
      </Grid>

      <Grid size={{ xs: 4 }} key="lv-product segment">
        <GenericSegmentCard
          data={transformDynamicSegmentData(productData)}
          periodFilter={periodFilter}
          setPeriodFilter={setPeriodFilter}
          sx={{ height: '100%' }}
        />
      </Grid>
    </Grid>
  </>
  )
}

LogisticsView.propTypes = {
  cardsData: PropTypes.arrayOf(PropTypes.object).isRequired,
}
